import { render, staticRenderFns } from "./SessionDetailsPage.vue?vue&type=template&id=68029d89&scoped=true&"
import script from "./SessionDetailsPage.vue?vue&type=script&lang=js&"
export * from "./SessionDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetailsPage.vue?vue&type=style&index=0&id=68029d89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68029d89",
  null
  
)

export default component.exports